import { useEffect } from "react";
import { scrollToId } from "@/lib/api";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Products } from "@/components/site/Products";
import { Process } from "@/components/site/Process";
import { Industries } from "@/components/site/Industries";
import { Faq } from "@/components/site/Faq";
import { Contact, Footer } from "@/components/site/Contact";

export default function Landing() {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return undefined;
    const t = setTimeout(() => scrollToId(id), 500);
    return () => clearTimeout(t);
  }, []);
  return (
    <div data-testid="landing-page" className="relative">
      <SmoothScroll />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <Process />
        <Industries />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
